module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-document-eac852ecd8b365780ec175ef25a2412a.svg";